import React, { useEffect, useRef } from 'react'
import { Link } from 'react-router-dom'
import { ROOT_PATH } from '../../Config/Constants'
import { APP_NAVIGATION } from "../../Util/Constants";
import PathHelper from '../../Util/PathHelper'

type Props = {}

const Footer = (props: Props) => {

  const currentYear = new Date().getFullYear()
  const footerRef = useRef<HTMLElement | null>(null)
  const [isMobile, setIsMobile] = React.useState<boolean>(() => typeof window !== 'undefined' ? window.innerWidth <= 767 : false)

  // Track viewport width so we only render footer on mobile.
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 767)
    window.addEventListener('resize', onResize)
    return () => window.removeEventListener('resize', onResize)
  }, [])

  useEffect(() => {
    if (!isMobile) return // only observe when footer is actually present
    const el = footerRef.current
    if (!el) return

    const setVar = () => {
      const h = el.offsetHeight || 0
      document.documentElement.style.setProperty('--minimal-footer-height', `${h}px`)
    }

    // Initial set
    setVar()

    // Observe footer size changes (content changes or responsive)
    let ro: ResizeObserver | null = null
    if ((window as any).ResizeObserver) {
      ro = new (window as any).ResizeObserver(() => {
        setVar()
      })
      if (ro && el) ro.observe(el)
    } else {
      // Fallback: update on window resize
      window.addEventListener('resize', setVar)
    }

    // Also watch for body class changes (e.g., .temp-footer toggled)
    const bodyObserver = new MutationObserver(mutations => {
      for (const m of mutations) {
        if (m.type === 'attributes' && (m as any).attributeName === 'class') {
          setVar()
        }
      }
    })
    bodyObserver.observe(document.body, { attributes: true })

    return () => {
      if (ro) ro.disconnect()
      else window.removeEventListener('resize', setVar)
      bodyObserver.disconnect()
    }
  }, [isMobile])
    const RedirectPrivacyPath = PathHelper(APP_NAVIGATION.PRVCY);
    const RedirectTermsPath = PathHelper(APP_NAVIGATION.TERMS);
    const RedirectContactPath = PathHelper(APP_NAVIGATION.CONPG);

    // if (!isMobile) return null

    return (
      <footer id="minimal-footer" ref={footerRef}>
        <div className="container">
          <div className="row">
            <div className="col-sm-12 align-self-center">
              <ul className="list-inline text-center mb-10">
                <li className="list-inline-item">
                  <Link
                    to={RedirectContactPath.next}
                    target="blank"
                    className="text-decoration-underline"
                  >
                    Contact Us
                  </Link>
                </li>
                <li className="list-inline-item">
                  <Link
                    to={RedirectTermsPath.next}
                    target="blank"
                    className="text-decoration-underline"
                  >
                    Terms and Conditions
                  </Link>
                </li>
                <li className="list-inline-item ">
                  <Link
                    to={RedirectPrivacyPath.next}
                    target="blank"
                    className="list-inline-item text-decoration-underline"
                  >
                    Privacy Policy
                  </Link>
                </li>
              </ul>
              <p className="text-center copyright">
                © {currentYear}, WorkSimpli Software, LLC. All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </footer>
    );
}

export default Footer
